import React from 'react';
import PropTypes from 'prop-types';
import './Separator.scss';

const Separator = ({ label = '' }) => (
  <div className="separator">
    <div className="line" />
    <div className="label">{label}</div>
  </div>
);

Separator.propTypes = {
  label: PropTypes.string,
};

export default Separator;
